import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
// import AllPagesNavbar from "../Components/MasterNavbar/AllPagesMasterNavbar";
import LoadingScreen from "../LoadingScreen";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const FuelAndMileageVouchers = () => {
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const [date, setDate] = useState(new Date().toISOString());
  const [contractno, setContractno] = useState("");
  const [selJobType, setSelJobType] = useState("");
  const [cargoCategory, setCargoCategory] = useState("");
  const [cargoClassification, setCargoClassification] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [routeId, setRouteId] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [clientName, setClientName] = useState("");
  const [narration, setNarration] = useState("");
  const [loadingPoint, setLoadingPoint] = useState("");
  const [selOffLoadingPoint, setSelOffLoadingPoint] = useState("");
  const [selTruck, setSelTruck] = useState("");
  const [model, setModel] = useState("");
  const [selTrailer, setSelTrailer] = useState("");
  const [selDriverName, setSelDriverName] = useState("");
  const [selDriverCode, setSelDriverCode] = useState("");
  const [selLocation, setSelLocation] = useState("");
  const [qty, setQty] = useState("");
  const [fuelRate, setFuelRate] = useState("");
  const [currency, setCurrency] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [subContracting, setSubContracting] = useState("");
  const [subContractCode, setSubContractCode] = useState("");
  const [subContractName, setSubContractName] = useState("");
  const [uom, setUom] = useState("");
  const [ShowVehicles, setShowVehicles] = useState(false);
  const [SearchVehicles, setSearchVehicles] = useState("");

  const [contractList, setContractList] = useState([]);
  const [offLoadingList, setOffLoadingList] = useState([]);
  const [truckList, setTruckList] = useState([]);
  const [trailerList, setTrailerList] = useState([]);
  const [loactionList, setLocationList] = useState([]);
  const [tableDetails, setTableDetails] = useState([]);
  const [truckDetails, setTruckDetails] = useState([]);
  const [ValidationAllbuttonValue, setValidationAllbuttonValue] = useState([]);
  console.log(truckDetails);
  console.log(trailerList);
  const [selectedRow, setSelectedRow] = useState(null); // State to hold selected row
  console.log(selectedRow);

  // Handle row selection
  const handleRowClick = (value) => {
    // Otherwise, select the new row
    setSelectedRow(value);
  };
  const [selectedRowIndex, setselectedRowIndex] = useState(null);
  const [showContracts, setShowContracts] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [isLoading, setIsloading] = useState(true);
  const [showSelectedTrucks, setShowSelectedTrucks] = useState(false);
  const [showTrucks, setShowTrucks] = useState(false);

  const [searchTrucks, setSearhTrucks] = useState("");
  const [searchContracts, setSearchContracts] = useState("");
  const [company, setCompany] = useState("");
  const [selectedRows, setSelectedRows] = useState({}); // Track which rows the user selects to process
  const [selectedTrucks, setSelectedTrucks] = useState([]);
  const [finalSelectedTrucks, setFinalSelectedTrucks] = useState([]);
  const [fileName, setFileName] = useState(""); // Add state for file name
  const fileInputRef = useRef(null);
  const [fieldNames, setFieldNames] = useState([]);
  const [excelData, setExcelData] = useState([]);
  const [containerListArray, setContainerListArray] = useState([]);
  console.log(finalSelectedTrucks);
  console.log(finalSelectedTrucks);
  const [EmailToSendList, setEmailToSendList] = useState([]);
  const [EmailToSendListLOADINGORDER, setEmailToSendListLOADINGORDER] =
    useState([]);
  const [EmailToSendListJOURNEY, setEmailToSendListJOURNEY] = useState([]);
  const [EmailToSendListFUEL, setEmailToSendListFUEL] = useState([]);
  const [EmailToSendListMILAGE, setEmailToSendListMILAGE] = useState([]);
  console.log(EmailToSendList);
  const [companyFilter, setDriverFilter] = useState(null);
  const [companyOptions, setDriverOptions] = useState([]);

  const [savedLoading, setSavedLoading] = useState(false);
  const [savedJourney, setSavedJourney] = useState(false);
  const [savedFuel, setSavedFuel] = useState(false);
  const [savedMileage, setSavedMileage] = useState(false);
  const [VehicleLoading, setVehicleLoading] = useState(false);
  const [trucksLoading, setTrucksLoading] = useState(false);
  const [fuelVoucherMap, setFuelVoucherMap] = useState({});
  const [popAllocatecontainers, setpopAllocatecontainers] = useState(false);
  const [DriverList, setDriverList] = useState([]);
  const [FuelToShow, setFuelToShow] = useState(""); // Add state for file name
  const [listOfFuelVouchers, setListOfFuelVouchers] = useState([]);
  const [showFuel, setShowFuel] = useState(false);
  const [searchFuel, setSearchFuel] = useState("");

  const [formData, setFormData] = useState({
    fuelVoucherNo: "",
    latestFuelVoucherNo: "",
    firstFuelVoucherNo: "",
    fuelVoucherList: [],
    showFuelVoucher: false,
    searchFuelVoucher: "",
    vehicle: "",
    vehicleList: [],
    fuelCriteria: "",
    fuelCriteriaList: [],
    loadingOrderNo: "",
    loadingOrderList: [],
    searchLoadingOrder: "",
    showLoadingOrder: false,
    trailer: "",
    Date: new Date().toISOString(),
    vehicleModel: "",
    vehicleMake: "",
    lotNo: "",
    trailerCategory: "",
    driverName: "",
    driverCode: "",
    journeyNo: "",
    searchJourney: "",
    journeyList: [],
    showJourney: false,
    searchTJourney: "",
    journeyTList: [],
    showTJourney: false,
    routeNo: "",
    routeList: [],
    showRoute: false,
    from: "",
    to: "",
    km: "",
    deliveries: "",
    fuelBal: "",
    standardQty: "",
    requestedQty: "",
    approvedQty: "",
    totalTank: "",
    minReqBal: "25",
    alreadyIssued: "",
    subCon: "",
    previousKm: "",
    previousFuelInTank: "",
    currentKm: "",
    kmCovered: "",
    kmLtr: "",
    fuelRate: "",
    currency: "",
    exchRate: "",
    narration: "",
    fromStation: "",
    fromStationList: [],
    subStation: "",
    emptyOrLoaded: "",
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    // Get distinct company names for the company filter options
    const companies = Array.from(
      new Set(DriverList?.map((item) => item?.["EMPLOYEE NAME"]))
    ).map((company) => ({
      value: company,
      label: company,
    }));
    setDriverOptions(companies);
  }, [DriverList]);
  // Filters
  const filtContract = contractList?.filter((item) => {
    const searchData = searchContracts
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "CONTRACTNO",
        "CARGOCATEGORY",
        "CARGOCLASSIFICATION",
        "ROUTEID",
        "ROUTEFROM",
        "ROUTETO",
        "LOADINGPOINT",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  // Filter Fule
  const filtFuel = listOfFuelVouchers?.filter((item) => {
    const searchData = searchFuel?.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OT_FUEL_ALLOCATION_NO",
        "OT_FUEL_ALLOCATION_VEHICLE_TRAILER_CATEGORY",
        "OT_FUEL_MILEAGE_ROUTE",
        "OT_FUEL_MILEAGE_ROUTE_FROM_CITY",
        "OT_FUEL_MILEAGE_ROUTE_TO_CITY",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    return textMatch;
  });

  const filtTrucks = truckDetails?.filter((item) => {
    const searchData = searchTrucks?.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !companyFilter?.value) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "VEHICLE REG NO",
        "MODEL",
        "DRIVDERNAME",
        "TRAILERNAME",
        "VEHICLE",
        "TRAILER",
        "DRIVERCODE",
        "QTY",
        "LOADINGORDERNO",
        "JOURNEYNO",
        "FUELVOUCHERNO",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    const matchesDriver = companyFilter
      ? item.DRIVDERNAME === companyFilter.value
      : true;

    return textMatch && matchesDriver;
  });

  // Filter Journey
  const filtJourney = formData?.journeyList?.filter((item) => {
    const searchData = formData?.searchJourney
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "DRIVER",
        "JOURNEYNO",
        "LOADINGORDERNO",
        "ROUTEID",
        "FROMPOINT",
        "TOPOINT",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    return textMatch;
  });

  // Filter T Journey
  const filtTJourney = formData?.journeyTList?.filter((item) => {
    const searchData = formData?.searchTJourney
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "DRIVER",
        "LOADINGORDERNO",
        "JOURNEYNO",
        "ROUTEID",
        "FROMPOINT",
        "TOPOINT",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    return textMatch;
  });

  // Filter Loading Order
  const filtLoadingOrder = formData?.loadingOrderList?.filter((item) => {
    const searchData = formData?.searchLoadingOrder
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "LOADINGORDERNO",
        "CONTRACTNO",
        "JOURNEYNO",
        "VEHICLE",
        "DRIVERNAME",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    return textMatch;
  });

  // Filter Fuel Voucher
  const filtFuelVoucher = formData?.fuelVoucherList?.filter((item) => {
    const searchData = formData?.searchFuelVoucher
      ?.toLowerCase()
      .split(" ")
      .filter(Boolean);

    if (searchData.length === 0) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return [
        "OT_FUEL_ALLOCATION_NO",
        "OT_JOB_LOADING_ORDER_NO",
        "OT_JOB_CARGO_QTY",
        "OT_FUEL_MILEAGE_ROUTE",
        "OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME",
        "OT_FUEL_ALLOCATION_FROM_LOCATION",
      ].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });
    return textMatch;
  });

  const handleCheckboxChange = (truck) => {
    setSelectedTrucks([]);
    setFinalSelectedTrucks([]);
    // Check if the selected truck's VEHICLE is in the truckList
    setSelectedTrucks([truck]);
    setFinalSelectedTrucks([truck]);
  };

  useEffect(() => {
    getCompanyDetails();
    getvehicleList();
    gettrailerList();
    getdriverlist();
    // getListofFuelLocations();
    getContracts();
  }, []);

  const getvehicleList = () => {
    setVehicleLoading(true);
    axios
      // .get(`${BASEURL}/vehicleList`, {
      // .get(`${BASEURL}/getvehiclelist`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        const filteredData = res?.data?.filter(
          (item) => item?.TRAILER === false
        );
        handleChange("vehicleList", filteredData);
        // setTruckList(res?.data);
        // setVehicleLoading(false);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Truck List", err);
        // setVehicleLoading(false);
      });
  };

  const gettrailerList = () => {
    axios
      // .get(`${BASEURL}/trailerList`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671&TRAILER=1`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => setTrailerList(res?.data?.recordset))
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Trailer List", err);
      });
  };
  //
  const getdriverlist = () => {
    axios
      // .get(`${BASEURL}/getdriverlist`, {
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=612&DESIGNATION=DRIVER&EMPLOYEE TERMINATED=0`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => setDriverList(res?.data?.recordset))
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Driver List", err);
      });
    axios
      // .get(`${BASEURL}/getjourneyarrivaldepatrurestatus`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=488`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => console.log(res.data))
      .catch((err) => {
        setIsloading(false);
        console.log(
          "Error While fetching getjourneyarrivaldepatrurestatus ",
          err
        );
      });
  };

  const getContracts = () => {
    axios
      // .get(`${BASEURL}/getFuelVoucherNo`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=385`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })

      .then((res) => {
        console.log(res?.data);
        handleChange("fuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
        handleChange("latestFuelVoucherNo", res?.data[0]?.FUELVOUCHERNO);
        setFuelToShow(res?.data[0]?.FUELVOUCHERNO);
      })
      .catch((error) => {
        console.error("Error fetching :", error);
      });

    axios
      .get(
        // `${BASEURL}/getMailRecipientsForTransactions?OT_TRANSACTION_FORM_NAME=FUEL ISSUE`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=346&OT_TRANSACTION_FORM_NAME=FUEL ISSUE`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      //FUEL ISSUE , MILEAGE ISSUE, LOADING ORDER , JOURNEY CREATION
      .then((res) => {
        console.log(res?.data);
        const emailList = res?.data?.map(
          (recipient) => recipient?.EMAILADDRESS
        );

        setEmailToSendListFUEL(emailList);
      })
      .catch((error) => {
        setIsloading(false);
        console.error("Error fetching :", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=358`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("fromStationList", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching 358:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=450`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("loadingOrderList", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching 450:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=363`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        // firstFuelVoucherNo;
        const sortedData = [...(res?.data || [])].sort(
          (a, b) =>
            Number(a.OT_FUEL_ALLOCATION_NO) - Number(b.OT_FUEL_ALLOCATION_NO)
        );
        handleChange(
          "firstFuelVoucherNo",
          sortedData?.[0]?.OT_FUEL_ALLOCATION_NO
        );
        handleChange("fuelVoucherList", res?.data);
      })
      .catch((error) => {
        console.error("Error fetching 363:", error);
      });

    axios
      // .get(`${BASEURL}/getListofContracts`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=329`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setContractList(res?.data?.recordset);
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Contract List", err);
      });

    // List Of Fuel Vouchers
    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=363`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessiontoken,
    //     },
    //   })

    //   .then((res) => {
    //     console.log("Before Setting Data : 363 :", Date.now().toLocaleString());
    //     setListOfFuelVouchers(res?.data);
    //     console.log("After Setting Data : 363 :", Date.now().toLocaleString());
    //     setIsloading(false);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching 363:", error);
    //   });
  };

  function getJourneyUponVehicle(vehicle) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=487&VEHICLE=${vehicle}&JOURNEYCLOSED=false`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
        const filterFuelIssued = res?.data?.filter(
          (item) => item.FUELISSUED === true
        );
        const filterFuelNotIssued = res?.data?.filter(
          (item) => item.FUELISSUED === false
        );
        handleChange("journeyTList", filterFuelIssued);
        handleChange("journeyList", filterFuelNotIssued);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Error fetching 487:", error);
      });
  }

  function getStandardQtyUponMakeAndRoute(make, models, route) {
    if (make && models && route) {
      axios
        .get(
          `${BASEURL_GLOBAL}/globalViewHandler?viewname=1194&OM_FUEL_TRACTOR_MAKE=${make}&OM_FUEL_TRACTOR_TYPE=${models}&OM_FUEL_ROUTE_ID=${route}`,
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        )
        .then((res) => {
          const fuelCriteriaEmptyData = res?.data?.filter(
            (item) => item?.OM_FUEL_KM_BASED == 1
          );

          if (formData?.fuelCriteria === "ROUTE") {
            if (formData?.emptyOrLoaded === "LOADED") {
              handleChange("standardQty", res?.data[0]?.OM_FUEL_RETURN_LOADED);
            } else if (formData?.emptyOrLoaded === "EMPTY") {
              handleChange("standardQty", res?.data[0]?.OM_FUEL_RETURN_EMPTY);
            }
          } else {
            if (formData?.emptyOrLoaded === "LOADED") {
              handleChange(
                "standardQty",
                fuelCriteriaEmptyData[0]?.OM_FUEL_RETURN_LOADED
              );
            } else if (formData?.emptyOrLoaded === "EMPTY") {
              handleChange(
                "standardQty",
                fuelCriteriaEmptyData?.OM_FUEL_RETURN_EMPTY
              );
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching 1194:", error);
        });
    }
  }

  const getFuelRateUponFromStation = (fromStation) => {
    axios
      .post(
        `${BASEURL}/getFuelRate`,
        {
          CURRDATE: moment(formData?.Date).format("DD/MM/YYYY"),
          LOCATION: fromStation,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => handleChange("fuelRate", res?.data.recordset[0]?.RATE))
      .catch((err) => console.log("error while fetching the fuel rate", err));
  };

  const getExchangeRate = (currency) => {
    axios
      .post(
        `${BASEURL}/getExchangeRate`,
        {
          CURRENCY: currency,
          CURRDATE: moment(formData?.Date).format("DD/MM/YYYY"),
          COMPNAME: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
        handleChange("exchRate", res?.data.recordset[0]?.RATE);
      })
      .catch((err) =>
        console.log("error while fetching the Exchange rate", err)
      );
  };

  function getCurrencyUponFromStation(fromStation) {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=567&OM_LOC_CODE=${fromStation}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
        handleChange("currency", res?.data[0]?.OM_LOCATION_CURRENCY);
        getExchangeRate(res?.data[0]?.OM_LOCATION_CURRENCY);
        setIsloading(false);
      })
      .catch((error) => {
        console.error("Error fetching 567:", error);
      });
  }

  useEffect(() => {
    if (contractno) {
      fetchTruckData();
    }
  }, [contractno]);
  function fetchTruckData() {
    setIsloading(true);

    axios
      // .get(`${BASEURL}/getLoadingOrderDetails?CONTRACTNO=${contractno}`, {
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=450&CONTRACTNO=${contractno}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
        console.log(res?.data);

        // Filter out duplicate vehicle numbers

        const validVehicles = res?.data.filter(
          (item) =>
            (item.FUELVOUCHERNO === 0 || item.FUELVOUCHERNO === null) &&
            item.JOURNEYNO !== 0
        );

        // Filter out duplicate vehicle numbers
        const uniqueVehicles = validVehicles.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.VEHICLE === item.VEHICLE)
        );
        // Update state with unique vehicle numbers
        setTruckDetails(uniqueVehicles);
        // setValidationAllbuttonValue(uniqueVehicles);
        pullSelectedData();
        // resetSelectedArrayWithAllFields();
        setIsloading(false);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Contract List", err);
      });
  }

  const getListofLoadingPoints = (contractno) => {
    // axios
    //   .post(
    //     `${BASEURL}/getListofLoadingPoints`,
    //     { CONTRACTNO: contractno },
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=330&CONTRACTNO=${contractno}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      )
      .then((res) => {
        setSelOffLoadingPoint(res?.data?.recordset[0]?.OFFLOADINGPOINT);
        setOffLoadingList(res?.data?.recordset);
      })
      .catch((err) =>
        console.log("Error While fetching Off Loading List", err)
      );
  };

  const getCompanyDetails = () => {
    axios
      // .get(`${BASEURL}/getCompanyDetails`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=602`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        setCompany(res?.data[0]?.ORGCODE);
      })
      .catch((err) => {
        setIsloading(false);
        console.log("Error While fetching Company Details", err);
      });
  };

  // ************************ Fetching Transaction Numbers  *******************

  async function getFuelVoucherNo() {
    try {
      const response = await axios.get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=385`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      );
      if (response.status === 201) {
        console.log(response?.data?.recordset[0]);

        return response?.data?.recordset[0]?.FUELVOUCHERNO;
      } else {
        alert(response.data.message);
      }
    } catch (error) {
      console.error(`Error while generating Fuel Voucher Number`, error);
      alert("Failed to generate Fuel Voucher Number");
    }
  }

  // ************************ Saving **************************************

  const [copiedTrucks, setCopiedTrucks] = useState([]);

  // State to hold selected containers for each truck

  useEffect(() => {
    // Perform a deep copy of the original selectedTrucks array
    pullSelectedData();
  }, [selectedTrucks]);
  function pullSelectedData() {
    setCopiedTrucks(JSON.parse(JSON.stringify(selectedTrucks)));
  }

  // Convert containerListArray to options for the select component
  // Handle save button click
  const fetchFuelDetailsForFuelBUtton = async () => {
    const confirm = window.confirm("Are you Sure You want to Proceed?");
    if (!confirm) {
      return;
    }

    if (selectedTrucks.length > 0) {
      let alertShown = false;

      try {
        const fetchPromises = selectedTrucks.map((truck) =>
          axios
            .get(
              // `${BASEURL}/getfueltobeissuedforcontracts?CONTRACTNO=${contractno}&VEHICLE=${truck.VEHICLE}&MAKE=${truck.MAKE}&TRACTORTYPE=${truck.MODEL}&ROUTEID=${truck.ROUTEID}`,
              `${BASEURL_GLOBAL}/globalViewHandler?viewname=615&CONTRACTNO=${contractno}&VEHICLE=${truck.VEHICLE}&MAKE=${truck.MAKE}&TRACTORTYPE=${truck.MODEL}&ROUTEID=${truck.ROUTEID}`,
              {
                headers: {
                  "auth-token": authToken,
                  "session-token": sessiontoken,
                },
              }
            )
            .then((response) => {
              if (response.data.length === 0 && !alertShown) {
                alert(
                  `Standard fuel quantity is not mapped for the selected route.`
                );
                alertShown = true;
                // Return null to stop further processing for this truck
                return null;
              }

              const fuelData = response.data;
              return fuelData.map((fuel) => ({
                ...truck,
                RETURNLOADEDFUEL: fuel.RETURNLOADEDFUEL,
                FROMLOCATION: fuel.FROMLOCATION,
                CURRENCY: fuel.CURRENCY,
                FUELRATE: fuel.FUELRATE,
                EXCHRATE: fuel.EXCHRATE,
              }));
            })
        );

        const responses = await Promise.all(fetchPromises);

        // Filter out null responses (i.e., those that triggered the alert)
        const allFuelDetails = responses
          .flatMap((response) => response)
          .filter(Boolean);

        if (allFuelDetails.length === 0) {
          // If all trucks failed due to missing fuel quantity, return early
          return;
        }

        setFinalSelectedTrucks(allFuelDetails); // Updates the state
        // Pass the updated trucks to the function directly
        ProcessFuelVoucher(allFuelDetails);
      } catch (err) {
        console.log(
          "Error While fetching Fuel To be issued for Contracts",
          err
        );
      }
    }
  };

  async function SaveFuelVoucher() {
    if (!formData?.fuelVoucherNo) {
      alert("Please provide Fuel Voucher No");
      return;
    }

    if (!formData?.journeyNo) {
      alert("Please provide Journey No");
      return;
    }

    if (!formData?.loadingOrderNo) {
      alert("Please provide Loading Order No");
      return;
    }

    if (!formData?.requestedQty) {
      alert("Please provide Requested Quantity");
      return;
    }

    if (!formData?.fromStation) {
      alert("Please provide From Station");
      return;
    }

    if (!formData?.narration) {
      alert("Please provide Narration");
      return;
    }

    try {
      setIsloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=141`,
        {
          FUELVOUCHERNO: Number(formData?.fuelVoucherNo),
          JOURNEYNO: Number(formData?.journeyNo),
          LOADINGORDERNO: Number(formData?.loadingOrderNo),
          JOBTYPE: "",
          ISSUEDATE: moment(formData?.Date).format("YYYY/MM/DD"),
          TRUCK: formData?.vehicle,
          DRIVERCODE: formData?.driverCode ? formData?.driverCode : "",
          DRIVERNAME: formData.driverName ? formData.driverName : "",
          VEHICLEMODEL: formData?.vehicleMake ? formData?.vehicleMake : "",
          TRAILERTYPE: "",
          TRAILERCATEGORY: formData?.trailerCategory
            ? formData?.trailerCategory
            : "",
          FUELQTY: formData?.requestedQty ? Number(formData?.requestedQty) : 0,
          NARRATION: formData?.narration ? formData?.narration : "",
          LOCATION: formData?.to ? formData?.to : "",
          FUELRATE: Number(formData?.fuelRate),
          KM: formData?.km ? formData?.km : 0,
          CREATEDBY: user,
          DIVISION: "",
          CURRENCY: formData?.currency ? formData?.currency : "",
          EXCHRATE: Number(formData?.exchRate),
          SUBCONTRACTED: 0,
          SUBCONTRACTORCODE: 0,
          ROUTEID: formData?.routeNo ? Number(formData?.routeNo) : 0,
          FUELSTATION: formData?.fromStation ? formData?.fromStation : "",
          TOPUP: 0,
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      );
      if (response.status === 201) {
        alert("Standard Fuel Issued Successfully");
        window.location.reload();
      } else {
        alert("Error while Issuing Standard Fuel");
      }
      setIsloading(false);
    } catch (err) {
      alert("Error while Issuing Standard Fuel");
      setIsloading(false);
    }
  }

  async function AmmendFuelVoucher() {
    if (!formData?.journeyNo) {
      alert("Please provide Journey No");
      return;
    }

    if (!formData?.fuelVoucherNo) {
      alert("Please Provide Fuel Voucher No");
      return;
    }

    try {
      setIsloading(true);
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1206`,
        {
          JOURNEYNO: formData?.journeyNo ? Number(formData?.journeyNo) : 0,
          VOUCHERNO: formData?.fuelVoucherNo
            ? Number(formData?.fuelVoucherNo)
            : 0,
          AMENDBY: user ? user : "",
          SUCCESS_STATUS: "",
          ERROR_STATUS: "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        }
      );
      alert("Fuel Voucher Ammended Successfully");
      setIsloading(false);
      window.location.reload();
    } catch (err) {
      setIsloading(false);
    }
  }

  async function ProcessFuelVoucher(updatedTrucks) {
    setIsloading(true);
    let successCount = 0;
    let errorCount = 0;
    let fuelVoucherMaps = {};

    // Create a map from selectedTrucks
    const journeyMap = {};
    selectedTrucks.forEach((truck) => {
      journeyMap[truck.JOURNEYNO] = truck.JOURNEYNO;
    });

    // Add JOURNEYNO to finalSelectedTrucks
    const updatedWithJourney = updatedTrucks.map((truck) => ({
      ...truck,
      JOURNEYNO: journeyMap[truck?.JOURNEYNO],
    }));

    for (let index = 0; index < updatedWithJourney.length; index++) {
      const value = updatedWithJourney[index];
      try {
        const fuelvoucherno = await getFuelVoucherNo();

        const truckNumber = value.VEHICLE;
        if (!fuelVoucherMaps[truckNumber]) {
          fuelVoucherMaps[truckNumber] = [];
        }
        fuelVoucherMaps[truckNumber].push(fuelvoucherno);

        const response = await axios.post(
          `${BASEURL}/insertFuelVoucher`,
          {
            FUELVOUCHERNO: Number(formData?.fuelVoucherNo),
            JOURNEYNO: Number(formData?.journeyNo),
            LOADINGORDERNO: Number(formData?.loadingOrderNo),
            JOBTYPE: "",
            ISSUEDATE: moment(formData?.Date).format("YYYY/MM/DD"),
            TRUCK: formData?.vehicle,
            DRIVERCODE: formData?.driverCode ? formData?.driverCode : "",
            DRIVERNAME: formData.driverName ? formData.driverName : "",
            VEHICLEMODEL: formData?.vehicleMake ? formData?.vehicleMake : "",
            TRAILERTYPE: "",
            TRAILERCATEGORY: formData?.trailerCategory
              ? formData?.trailerCategory
              : "",
            FUELQTY: Number(formData?.standardQty),
            NARRATION: formData?.narration ? formData?.narration : "",
            LOCATION: formData?.to ? formData?.to : "",
            FUELRATE: Number(formData?.fuelRate),
            KM: formData?.km ? formData?.km : 0,
            CREATEDBY: user,
            DIVISION: "",
            CURRENCY: formData?.currency ? formData?.currency : "",
            EXCHRATE: Number(formData?.exchRate),
            SUBCONTRACTED: 0,
            SUBCONTRACTORCODE: 0,
            ROUTEID: formData?.routeNo ? Number(formData?.routeNo) : 0,
            FUELSTATION: formData?.fromStation ? formData?.fromStation : "",
            TOPUP: 0,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          }
        );

        if (response.status === 201) {
          successCount++;
        } else {
          errorCount++;
        }

        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        console.error(`Error while Processing Fuel Voucher`, error);
        alert(error.response.data.message);
      }
    }

    setIsloading(false);
    if (successCount === updatedWithJourney.length) {
      alert("Fuel vouchers processed successfully!");
      window.location.reload();
      setFuelVoucherMap(fuelVoucherMaps);
      setTruckDetails([]);
      fetchTruckData();
      setSavedFuel(true);
    }
  }

  // const sendEmailAsyncFuel = (emailData) => {
  //   const [firstEmail, ...bccEmails] = EmailToSendListFUEL;

  //   console.log({ to: firstEmail, bcc: bccEmails.join(",") });
  //   const mailData = {
  //     formatType: "html",
  //     message: BatchFuelEmail(emailData),
  //     subject: "BATCH PROCESSING FUEL",
  //     to: firstEmail,
  //     bcc: bccEmails.join(","),
  //   };

  //   // Make the email request without waiting for it
  //   axios
  //     .post(
  //       `https://marstrackbackend.azurewebsites.net/mail/triggerMail`,
  //       mailData,
  //       {
  //         headers: {
  //           "auth-token": authToken,
  //           "session-token": sessiontoken,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log(`Email sent to ${mailData.to}:`, res.data);
  //     })
  //     .catch((error) => {
  //       console.error(`Error sending email to ${mailData.to}:`, error);
  //     });
  // };

  const handleButtonClick = (action) => {
    let fuelVoucherToPass;
    switch (action) {
      case "first":
        fuelVoucherToPass = Number(formData?.firstFuelVoucherNo);
        break;
      case "decrement":
        fuelVoucherToPass = Number(formData?.fuelVoucherNo) - 1;
        if (fuelVoucherToPass < Number(formData?.firstFuelVoucherNo)) {
          alert("Cannot decrement further");
          return;
        }
        break;

      case "increment":
        fuelVoucherToPass = Number(formData?.fuelVoucherNo) + 1;
        if (fuelVoucherToPass >= Number(formData?.latestFuelVoucherNo)) {
          alert("No Further PO number");
          return;
        }
        break;

      case "latest":
        fuelVoucherToPass = Number(formData?.latestFuelVoucherNo) - 1;
        break;
      default:
        break;
    }

    handleChange("fuelVoucherNo", fuelVoucherToPass);
    getNavData(fuelVoucherToPass);
  };

  function getNavData(fuelVoucher) {
    const item = formData?.fuelVoucherList?.find(
      (item) => item?.OT_FUEL_ALLOCATION_NO === fuelVoucher
    );

    handleChange("fuelVoucherNo", item?.OT_FUEL_ALLOCATION_NO);
    handleChange("journeyNo", item?.OT_FUEL_ALLOCATION_JOB_NO);
    handleChange("Date", item?.OT_FUEL_ALLOCATION_CREATED_dATE);
    handleChange("loadingOrderNo", item?.OT_JOB_LOADING_ORDER_NO);
    // handleChange("standardQty", item?.OT_JOB_CARGO_QTY);
    handleChange("routeNo", item?.OT_FUEL_MILEAGE_ROUTE);

    handleChange("driverName", item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME);

    handleChange("driverCode", item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_CODE);
    handleChange("vehicle", item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO);
    const vehicle = formData?.vehicleList?.find(
      (items) =>
        items["VEHICLE REG NO"] === item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO
    );
    handleChange("vehicleMake", vehicle?.MAKE);
    handleChange("vehicleModel", vehicle?.MODEL);
    handleChange("trailer", vehicle?.["TRAILER NAME ATTACHED"]);

    handleChange("fromStation", item?.OT_FUEL_ALLOCATION_FROM_LOCATION);
    handleChange("narration", item?.OT_FUEL_ALLOCATION_NARRATION);
    handleChange("from", item?.OM_ROUTE_START);
    handleChange("to", item?.OM_ROUTE_END);
    handleChange("currency", item?.OT_FUEL_CURRENCY);
    handleChange("exchRate", item?.OT_FUEL_EXCH_RATE);
    handleChange("fuelRate", item?.OT_FUEL_ALLOCATION_RATE);

    handleChange("standardQty", item?.OT_FUEL_ALLOCATION_TO_BE_UTILIZED);
    handleChange("approvedQty", item?.OT_FUEL_ALLOCATION_AMOUNT);
    handleChange("totalTank", item?.OT_FUEL_ALLOCATION_TOTAL_IN_TANK);
    // handleChange("", item?.OT_FUEL_ALLOCATION_FINAL_AMOUNT);
    handleChange(
      "emptyOrLoaded",
      item?.OT_FUEL_ISSUE_RETURN_LOAD === true ? "LOADED" : "EMPTY"
    );
    // handleChange("", item?.OT_MILEAGE_ALLOCATION_TOP_UP_FUEL);
    // handleChange("", item?.OT_FUEL_MILEAGE_ALLOCATION_ON_KM);
  }

  // if (VehicleLoading) {
  //   return <LoadingSpinner />;
  // }
  return (
    <div>
      {isLoading && <LoadingScreen />}
      <section className="block print:hidden text-xs">
        <AllPagesNavbar />
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          STANDARD FUEL ISSUE
        </h1>
        {/* Buttons */}
        <aside className="lg:flex justify-between pr-2 gap-2 mt-1 mb-1">
          <div className="flex">
            <div className="flex lg:ml-2 gap-1 lg:mr-2">
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("first");
                }}
              >
                {"<<"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("decrement");
                }}
              >
                {"<"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("increment");
                }}
              >
                {">"}
              </button>
              <button
                className="flex h-7 items-center justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]"
                onClick={() => {
                  handleButtonClick("latest");
                }}
              >
                {">>"}
              </button>
            </div>

            <button
              className="border h-7 border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                window.location.reload();
              }}
            >
              New Voucher
            </button>

            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await SaveFuelVoucher();
              }}
            >
              Save to Request
            </button>

            <button
              className="h-7 border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                // window.location.reload();
              }}
            >
              Approve Voucher
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                window.print();
              }}
            >
              Print Fuel Voucher
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await AmmendFuelVoucher();
              }}
            >
              Ammend
            </button>

            <button
              className="h-7  border border-black bg-[#002d62] text-white rounded-md px-3   mr-1 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                // window.location.reload();
              }}
            >
              Cancel
            </button>
          </div>
          {/* <div className="flex">
            <FaArrowLeft
              className="cursor-pointer hover:text-blue-300 transition-all"
              size={30}
              onClick={() => {
                window.history.back();
              }}
            />
          </div> */}
        </aside>
        {/* Headers */}
        <div className="bg-slate-100 m-1 rounded-md p-1 pb-2 h-auto">
          {/* Header Line  */}
          <div className="lg:flex mt-2 justify-between">
            <div className="flex">
              <Select
                className="w-40"
                value={
                  formData?.emptyOrLoaded
                    ? {
                        value: formData?.emptyOrLoaded,
                        label: formData?.emptyOrLoaded,
                      }
                    : { value: "", label: "Select Empty / Loaded" }
                }
                onChange={(e) => {
                  handleChange("emptyOrLoaded", e.value);
                }}
                options={[
                  { value: "EMPTY", label: "EMPTY" },
                  { value: "LOADED", label: "LOADED" },
                ]}
              ></Select>
            </div>
            <div className="flex">
              <button
                className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                // onClick={() => {
                //   handleChange("showFuelVoucher", true);
                // }}
              >
                Hydraulic Check History
              </button>
              <span className="lg:ml-1 block">Previous Fuel Issued :</span>
              <input
                readOnly
                className="w-20 h-7  text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              ></input>
            </div>
          </div>

          {/* First Line */}
          <div className="lg:flex mt-2">
            <span className="lg:ml-1 block">Fuel Voucher No :</span>
            <input
              readOnly
              className="w-20 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fuelVoucherNo}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showFuelVoucher", true);
              }}
            >
              ...
            </button>

            {formData?.showFuelVoucher && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchFuelVoucher}
                    onChange={(e) => {
                      handleChange("searchFuelVoucher", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showFuelVoucher", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FUEL VOUCHER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADING ORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          QUANTITY
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM STATION
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtFuelVoucher?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            handleChange(
                              "fuelVoucherNo",
                              item?.OT_FUEL_ALLOCATION_NO
                            );
                            handleChange(
                              "journeyNo",
                              item?.OT_FUEL_ALLOCATION_JOB_NO
                            );
                            handleChange(
                              "Date",
                              item?.OT_FUEL_ALLOCATION_CREATED_dATE
                            );
                            handleChange(
                              "loadingOrderNo",
                              item?.OT_JOB_LOADING_ORDER_NO
                            );
                            // handleChange("standardQty", item?.OT_JOB_CARGO_QTY);
                            handleChange(
                              "routeNo",
                              item?.OT_FUEL_MILEAGE_ROUTE
                            );

                            handleChange(
                              "driverName",
                              item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME
                            );

                            handleChange(
                              "driverCode",
                              item?.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_CODE
                            );
                            handleChange(
                              "vehicle",
                              item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO
                            );
                            const vehicle = formData?.vehicleList?.find(
                              (items) =>
                                items["VEHICLE REG NO"] ===
                                item?.OT_FUEL_ALLOCATION_VEHICLE_REG_NO
                            );
                            handleChange("vehicleMake", vehicle?.MAKE);
                            handleChange("vehicleModel", vehicle?.MODEL);
                            handleChange(
                              "trailer",
                              vehicle?.["TRAILER NAME ATTACHED"]
                            );

                            handleChange(
                              "fromStation",
                              item?.OT_FUEL_ALLOCATION_FROM_LOCATION
                            );
                            handleChange(
                              "narration",
                              item?.OT_FUEL_ALLOCATION_NARRATION
                            );
                            handleChange("from", item?.OM_ROUTE_START);
                            handleChange("to", item?.OM_ROUTE_END);
                            handleChange("currency", item?.OT_FUEL_CURRENCY);
                            handleChange("exchRate", item?.OT_FUEL_EXCH_RATE);
                            handleChange(
                              "fuelRate",
                              item?.OT_FUEL_ALLOCATION_RATE
                            );
                            handleChange(
                              "standardQty",
                              item?.OT_FUEL_ALLOCATION_TO_BE_UTILIZED
                            );
                            handleChange(
                              "approvedQty",
                              item?.OT_FUEL_ALLOCATION_AMOUNT
                            );
                            handleChange(
                              "totalTank",
                              item?.OT_FUEL_ALLOCATION_TOTAL_IN_TANK
                            );
                            // handleChange("", item?.OT_FUEL_ALLOCATION_FINAL_AMOUNT);
                            handleChange(
                              "emptyOrLoaded",
                              item?.OT_FUEL_ISSUE_RETURN_LOAD === true
                                ? "LOADED"
                                : "EMPTY"
                            );
                            // handleChange("", item?.OT_MILEAGE_ALLOCATION_TOP_UP_FUEL);
                            // handleChange("", item?.OT_FUEL_MILEAGE_ALLOCATION_ON_KM);
                            handleChange("showFuelVoucher", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_NO
                              ? item.OT_FUEL_ALLOCATION_NO
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.OT_JOB_LOADING_ORDER_NO
                              ? item.OT_JOB_LOADING_ORDER_NO
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.OT_JOB_CARGO_QTY
                              ? item.OT_JOB_CARGO_QTY
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.OT_FUEL_MILEAGE_ROUTE
                              ? item.OT_FUEL_MILEAGE_ROUTE
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME
                              ? item.OT_FUEL_ALLOCATION_VEHICLE_DRIVER_NAME
                              : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_FROM_LOCATION
                              ? item.OT_FUEL_ALLOCATION_FROM_LOCATION
                              : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <span className="lg:ml-2 mr-2 block">Vehicle :</span>
            <Select
              className="w-40"
              value={
                formData?.vehicle
                  ? { value: formData?.vehicle, label: formData?.vehicle }
                  : { value: "", label: "Select Vehicle" }
              }
              onChange={(e) => {
                if (!formData?.emptyOrLoaded) {
                  alert("Kindly Supply the status Empty/Loaded");
                } else {
                  if (e.value !== "") {
                    handleChange("vehicle", e.value);
                    const vehicle = formData?.vehicleList?.find(
                      (item) => item["VEHICLE REG NO"] === e.value
                    );
                    handleChange("vehicleMake", vehicle?.MAKE);
                    handleChange("vehicleModel", vehicle?.MODEL);
                    handleChange("driverCode", vehicle?.DRIVERCODE);
                    handleChange("driverName", vehicle?.DRIVERNAME);
                    handleChange("trailer", vehicle?.["TRAILER NAME ATTACHED"]);
                    getJourneyUponVehicle(e.value);
                  } else {
                    handleChange("vehicle", e.value);
                  }
                }
              }}
              options={[
                { value: "", label: "Select Vehicle" },
                ...formData?.vehicleList?.map((item) => ({
                  value: item["VEHICLE REG NO"],
                  label: item["VEHICLE REG NO"],
                })),
              ]}
            ></Select>

            <span className="lg:ml-2 mr-2 block">Fuel Criteria :</span>
            <Select
              className="w-32"
              value={
                formData?.fuelCriteria
                  ? {
                      value: formData?.fuelCriteria,
                      label: formData?.fuelCriteria,
                    }
                  : { value: "", label: "Select Fuel Criteria" }
              }
              onChange={(e) => handleChange("fuelCriteria", e.value)}
              options={[
                { value: "", label: "Select Fuel Criteria" },
                { value: "ROUTE", label: "ROUTE" },
              ]}
            ></Select>

            <span className="lg:ml-2 block">Loading Order No :</span>
            <input
              readOnly
              className="w-20 h-7  text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.loadingOrderNo}
              // value={FuelToShow ? FuelToShow : ""}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showLoadingOrder", true);
              }}
            >
              ...
            </button>

            {formData?.showLoadingOrder && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchLoadingOrder}
                    onChange={(e) => {
                      handleChange("searchLoadingOrder", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showLoadingOrder", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADINGORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          CONTRACT NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          VEHICLE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME{" "}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtLoadingOrder?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            handleChange("journeyNo", item?.JOURNEYNO);
                            handleChange("routeNo", item?.ROUTEID);
                            handleChange("from", item?.FROMPOINT);
                            handleChange("to", item?.TOPOINT);
                            handleChange("showLoadingOrder", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.LOADINGORDERNO ? item.LOADINGORDERNO : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.CONTRACTNO ? item.CONTRACTNO : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.JOURNEYNO ? item.JOURNEYNO : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.VEHICLE ? item.VEHICLE : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.DRIVERNAME ? item.DRIVERNAME : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <span className="lg:ml-1">Trailer :</span>
            <input
              readOnly
              className="w-36 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.trailer}
            ></input>

            <span className="lg:ml-1">Date :</span>
            <input
              type="date"
              className="w-28 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.Date?.split("T")[0]}
              onChange={(e) => handleChange("Date", e.target.value)}
            ></input>
          </div>

          {/* 2nd line  */}
          <div className="lg:flex mt-2">
            <span className="block lg:ml-1">Vehicle Model :</span>
            <input
              readOnly
              className="w-48 h-7 lg:ml-4 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.vehicleModel}
            ></input>
            <span className="mx-2 block">Vehicle Make :</span>
            <input
              readOnly
              className="w-48 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.vehicleMake}
            ></input>
            <span className="mx-2 block">Lot No :</span>
            <input
              readOnly
              className="w-20 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.lotNo}
            ></input>
            <span className="mx-2 block">Trailer Category :</span>
            <input
              readOnly
              className="w-48 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.trailerCategory}
            ></input>
            <span className="mx-2 block">Driver :</span>
            <input
              readOnly
              className="w-48 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.driverName}
            ></input>
          </div>

          {/* 3rd Line  */}
          <div className="lg:flex mt-2">
            <span className="lg:ml-1 block">Journey No :</span>
            <input
              readOnly
              className="w-20 h-7 lg:ml-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.journeyNo}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showJourney", true);
              }}
            >
              ...
            </button>

            {formData?.showJourney && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchJourney}
                    onChange={(e) => {
                      handleChange("searchJourney", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showJourney", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY DATE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADINGORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE ID
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM LOCATION
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          TO LOCATION
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtJourney?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            handleChange("journeyNo", item?.JOURNEYNO);
                            handleChange(
                              "loadingOrderNo",
                              item?.LOADINGORDERNO
                            );
                            handleChange("routeNo", item?.ROUTEID);
                            handleChange("from", item?.FROMPOINT);
                            handleChange("to", item?.TOPOINT);
                            getStandardQtyUponMakeAndRoute(
                              formData?.vehicleMake,
                              item?.ROUTEID
                            );
                            handleChange("showJourney", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.JOURNEYNO ? item.JOURNEYNO : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.JOURNEYDATE
                              ? item.JOURNEYDATE.slice(8, 10) +
                                "/" +
                                item.JOURNEYDATE.slice(5, 7) +
                                "/" +
                                item.JOURNEYDATE.slice(0, 4)
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.LOADINGORDERNO ? item.LOADINGORDERNO : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.DRIVER ? item.DRIVER : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.ROUTEID ? item.ROUTEID : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.FROMPOINT ? item.FROMPOINT : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.TOPOINT ? item.TOPOINT : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                handleChange("showTJourney", true);
              }}
            >
              T
            </button>

            {formData?.showTJourney && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={formData?.searchTJourney}
                    onChange={(e) => {
                      handleChange("searchTJourney", e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => handleChange("showTJourney", false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY DATE
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADINGORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          DRIVER NAME
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE ID
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM LOCATION
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          TO LOCATION
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtTJourney?.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            handleChange("journeyNo", item?.JOURNEYNO);
                            handleChange(
                              "loadingOrderNo",
                              item?.LOADINGORDERNO
                            );
                            handleChange("routeNo", item?.ROUTEID);
                            handleChange("from", item?.FROMPOINT);
                            handleChange("to", item?.TOPOINT);
                            getStandardQtyUponMakeAndRoute(
                              formData?.vehicleMake,
                              item?.ROUTEID
                            );
                            handleChange("showTJourney", false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.JOURNEYNO ? item.JOURNEYNO : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.JOURNEYDATE
                              ? item.JOURNEYDATE.slice(8, 10) +
                                "/" +
                                item.JOURNEYDATE.slice(5, 7) +
                                "/" +
                                item.JOURNEYDATE.slice(0, 4)
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.LOADINGORDERNO ? item.LOADINGORDERNO : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.DRIVER ? item.DRIVER : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.ROUTEID ? item.ROUTEID : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.FROMPOINT ? item.FROMPOINT : "NA"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.TOPOINT ? item.TOPOINT : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <span className="lg:ml-6 block lg:mr-1">Route :</span>
            <input
              readOnly
              className="w-20 h-7 lg:ml-12 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.routeNo}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                setShowFuel(true);
              }}
            >
              ...
            </button>

            {showFuel && (
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[600] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
                <div className="lg:flex items-center gap-3">
                  <span className="text-lg font-semibold ml-2">Saved Fuel</span>
                </div>
                <div className="lg:flex lg:flex-row mt-2">
                  <p className="text-red-600 lg:ml-2">Search:</p>
                  <input
                    className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                    type="text"
                    value={searchFuel}
                    onChange={(e) => {
                      setSearchFuel(e.target.value);
                    }}
                  ></input>
                </div>
                <button
                  className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => setShowFuel(false)}
                >
                  Close
                </button>
                <div className="visible lg:h-[400px] p-1 z-0 lg:overflow-auto mt-2">
                  <table className="w-full border border-gray-300 text-sm">
                    <thead className="sticky top-0">
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          VOUCHER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADING POINT
                        </td>
                        {/* <td className="py-2 px-4 text-left border border-gray-300">CATEGORY</td> */}
                        {/* <td className="py-2 px-4 text-left border border-gray-300">FUEL DATE</td> */}
                        <td className="py-2 px-4 text-left border border-gray-300">
                          ROUTE ID
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          FROM LOCATION
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          TO LOCATION
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      {filtFuel.map((item, index) => (
                        <tr
                          className="hover:bg-gray-100 cursor-pointer text-[13px]"
                          onClick={() => {
                            setFuelToShow(item?.OT_FUEL_ALLOCATION_NO);
                            // setCargoCategory(
                            //   item?.OT_FUEL_ALLOCATION_VEHICLE_TRAILER_CATEGORY
                            // );
                            setRouteId(item?.OT_FUEL_MILEAGE_ROUTE);
                            setFrom(item?.OT_FUEL_MILEAGE_ROUTE_FROM_CITY);
                            setTo(item?.OT_FUEL_MILEAGE_ROUTE_TO_CITY);
                            setLoadingPoint(
                              item?.OT_FUEL_ALLOCATION_FROM_LOCATION
                            );
                            setNarration(item?.OT_FUEL_ALLOCATION_NARRATION);
                            setQty(item?.OT_FUEL_ALLOCATION_TO_BE_UTILIZED);
                            setShowFuel(false);
                          }}
                        >
                          <td className="py-2 px-4 text-right border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_NO
                              ? item.OT_FUEL_ALLOCATION_NO
                              : "NA"}
                          </td>
                          {/* <td className="py-2 px-4 text-left border border-gray-300" className="  pr-5 text-right">
                            {item.OT_FUEL_ALLOCATION_VEHICLE_TRAILER_CATEGORY
                              ? item.OT_FUEL_ALLOCATION_VEHICLE_TRAILER_CATEGORY
                              : "N/A"}
                          </td> */}

                          {/* <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_DATE
                              ? item.OT_FUEL_ALLOCATION_DATE.slice(8, 10) +
                                "/" +
                                item.OT_FUEL_ALLOCATION_DATE.slice(5, 7) +
                                "/" +
                                item.OT_FUEL_ALLOCATION_DATE.slice(0, 4)
                              : "N/A"}
                          </td> */}

                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_ALLOCATION_FROM_LOCATION
                              ? item.OT_FUEL_ALLOCATION_FROM_LOCATION
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_MILEAGE_ROUTE
                              ? item.OT_FUEL_MILEAGE_ROUTE
                              : "N/A"}
                          </td>
                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_MILEAGE_ROUTE_FROM_CITY
                              ? item.OT_FUEL_MILEAGE_ROUTE_FROM_CITY
                              : "NA"}
                          </td>

                          <td className="py-2 px-4 text-left border border-gray-300">
                            {item.OT_FUEL_MILEAGE_ROUTE_TO_CITY
                              ? item.OT_FUEL_MILEAGE_ROUTE_TO_CITY
                              : "NA"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}

            <span className="mx-2 block">From :</span>
            <input
              readOnly
              className="w-48 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.from}
            ></input>

            <span className="mx-2 block">To :</span>
            <input
              readOnly
              className="w-48 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.to}
            ></input>

            <span className="mx-2 block">Km :</span>
            <input
              readOnly
              className="w-20 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.km}
              onChange={(e) => handleChange("km", e.target.value)}
            ></input>

            <span className="mx-2 block">Deliveries :</span>
            <input
              readOnly
              className="w-20 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.deliveries}
            ></input>
          </div>

          {/* 4th line */}
          <div className="lg:flex mt-2">
            <span className="block lg:ml-1">Fuel Bal :</span>
            <input
              className="w-32 h-7 lg:ml-12 lg:mr-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.fuelBal}
              onChange={(e) => {
                if (formData?.approvedQty > 0) {
                  handleChange(
                    "totalTank",
                    Number(formData?.approvedQty) + Number(e.target.value)
                  );
                  handleChange("fuelBal", e.target.value);
                } else {
                  handleChange("fuelBal", e.target.value);
                }
              }}
            ></input>
            <span className="mx-2 block lg:ml-16">Standard Qty :</span>
            <input
              className="w-20 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.standardQty ? formData?.standardQty : 0}
              readOnly
              // onChange={(e) => handleChange("standardQty", e.target.value)}
            ></input>
            <span className="lg:ml-2 block">Requested Qty :</span>
            <input
              className="w-20 h-7 lg:ml-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.requestedQty}
              onChange={(e) => handleChange("requestedQty", e.target.value)}
            ></input>
            <span className="lg:ml-14 block">Approved Qty :</span>
            <input
              className="w-20 h-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.approvedQty}
              onChange={(e) => {
                handleChange("approvedQty", e.target.value);
                handleChange(
                  "totalTank",
                  Number(e.target.value) + Number(formData?.fuelBal)
                );
              }}
            ></input>
            <span className="lg:ml-20 block">Total(Tank) :</span>
            <input
              className="w-32 h-7 text-right pr-2 lg:ml-1 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
              value={formData?.totalTank}
              readOnly
            ></input>
          </div>

          {/* 5th line  */}
          <div className="flex mt-2">
            <div className="flex flex-col">
              {/* 1st sub  */}
              <div className="lg:flex mt-2">
                <span className="block">Min Req Bal :</span>
                <input
                  className="w-32 h-7 lg:ml-7 text-right pr-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.minReqBal}
                  onChange={(e) => handleChange("minReqBal", e.target.value)}
                ></input>
                <span className="mx-2 block">
                  Already Issued for the journey :
                </span>
                <input
                  className="w-32 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.alreadyIssued}
                  onChange={(e) =>
                    handleChange("alreadyIssued", e.target.value)
                  }
                ></input>
                <span className="mx-2 block">Subcon :</span>
                <input
                  className="w-32 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.subCon}
                  onChange={(e) => handleChange("subCon", e.target.value)}
                ></input>
              </div>
              {/* 2nd sub */}
              <div className="lg:flex mt-2">
                <span className="block">Narration :</span>
                <textarea
                  className="lg:w-[485px] h-16 lg:ml-11 resize-none w-[95%] border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.narration}
                  onChange={(e) => handleChange("narration", e.target.value)}
                ></textarea>
              </div>
              {/* 3rd sub */}
              <div className="lg:flex mt-2">
                <span className="block">From Station:</span>
                <Select
                  className="w-80 lg:ml-6"
                  value={
                    formData?.fromStation
                      ? {
                          value: formData?.fromStation,
                          label: formData?.fromStation,
                        }
                      : { value: "", label: "Select From Station" }
                  }
                  onChange={(e) => {
                    if (e.value !== "") {
                      getCurrencyUponFromStation(e.value);
                      getFuelRateUponFromStation(e.value);
                      handleChange("fromStation", e.value);
                    } else {
                      handleChange("fromStation", e.value);
                    }
                  }}
                  options={[
                    { value: "", label: "Select From Station" },
                    ...formData?.fromStationList?.map((item) => ({
                      value: item.FUELLOCATIONNAME,
                      label: item.FUELLOCATIONNAME,
                    })),
                  ]}
                ></Select>
              </div>
              {/* 4th sub */}
              <div className="lg:flex mt-2">
                <span className="block">Sub Station:</span>
                <Select
                  className="w-80 lg:ml-8"
                  value={
                    formData?.subStation
                      ? {
                          value: formData?.subStation,
                          label: formData?.subStation,
                        }
                      : { value: "", label: "Select Sub Station" }
                  }
                  onChange={(e) => handleChange("subStation", e.value)}
                  options={
                    offLoadingList.length === 0
                      ? [{ value: "NOT APPLICABLE", label: "NOT APPLICABLE" }]
                      : [
                          { value: "", label: "Select Off Loading Point" },
                          ...offLoadingList.map((item) => ({
                            value: item.OFFLOADINGPOINT,
                            label: item.OFFLOADINGPOINT,
                          })),
                        ]
                  }
                ></Select>
              </div>
            </div>
            <div className="flex">
              {/* seperate Tab */}
              <div className="flex flex-col">
                <p>Mileage Readings</p>
                <div className="flex gap-2 lg:mt-1">
                  <span className="lg:ml-2 block">Previous KM :</span>
                  <input
                    readOnly
                    className="lg:ml-14 w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={formData?.previousKm}
                    onChange={(e) => handleChange("previousKm", e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2 lg:mt-1">
                  <span className="lg:ml-2 block">Previous Fuel in Tank :</span>
                  <input
                    readOnly
                    className="w-36 h-7 lg:ml-2 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={formData?.previousFuelInTank}
                    onChange={(e) =>
                      handleChange("previousFuelInTank", e.target.value)
                    }
                  ></input>
                </div>
                <div className="flex gap-2 lg:mt-1">
                  <span className="lg:ml-2 block">Current KM :</span>
                  <input
                    readOnly
                    className="lg:ml-14 w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={formData?.currentKm}
                    // onChange={(e) => handleChange("currentKm", e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2 lg:mt-1">
                  <span className="lg:ml-2 block">KM Covered :</span>
                  <input
                    readOnly
                    className="lg:ml-14 w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={formData?.kmCovered}
                    onChange={(e) => handleChange("kmCovered", e.target.value)}
                  ></input>
                </div>
                <div className="flex gap-2 lg:mt-1">
                  <span className="lg:ml-2 block">KM / Ltr :</span>
                  <input
                    readOnly
                    className="lg:ml-20 w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                    value={formData?.kmLtr}
                    onChange={(e) => handleChange("kmLtr", e.target.value)}
                  ></input>
                </div>
              </div>
              <div className="flex flex-col lg:mt-1">
                <span className="mx-2 block">Fuel Rate :</span>
                <input
                  readOnly
                  className="w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.fuelRate}
                  onChange={(e) => handleChange("fuelRate", e.target.value)}
                ></input>
                <span className="mx-2 block">Currency :</span>
                <input
                  readOnly
                  className="w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.currency}
                  onChange={(e) => handleChange("currency", e.target.value)}
                ></input>
                <span className="mx-2 block">Exch Rate :</span>
                <input
                  readOnly
                  className="w-36 h-7 border border-black p-2 rounded-md focus:outline-none focus:border-blue-500"
                  value={formData?.exchRate}
                  onChange={(e) => handleChange("exchRate", e.target.value)}
                ></input>
              </div>
            </div>
          </div>

          {ShowVehicles && (
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[500px] h-[80%] lg:w-[1100px] w-[95%] p-1 overflow-y-auto">
              <div className="lg:flex items-center gap-3">
                <span className="text-lg font-semibold ml-2">
                  Select Vehicle{" "}
                </span>
              </div>
              <div className="lg:flex lg:flex-row mt-2 items-center">
                <p className="text-red-600 lg:ml-2">Search:</p>
                <input
                  className="lg:w-[300px] h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={searchTrucks}
                  onChange={(e) => {
                    setSearhTrucks(e.target.value);
                  }}
                ></input>
                <div className="lg:flex items-center gap-4 lg:px-2 px-5 mt-2">
                  <p>Driver:</p>
                  <Select
                    className="lg:w-[400px] w-full text-sm z-[200] "
                    value={companyFilter}
                    onChange={setDriverFilter}
                    options={companyOptions}
                    placeholder="Select a Driver"
                    isClearable
                    isSearchable
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "lightblue",
                        primary: "lightblue",
                      },
                    })}
                  />
                </div>
              </div>
              <button
                className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setShowVehicles(false)}
              >
                Close
              </button>
              <div className="overflow-y-auto h-[500px]">
                {truckDetails.length > 0 ? (
                  <table className="custom-table text-sm overflow__y__ relative ">
                    <thead
                      className="header-cell sticky top-[0px] left-[10px]"
                      style={{ zIndex: 50 }}
                    >
                      <tr className="bg-[#2b3f5c] text-white text-[12px]">
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Truck
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Trailer
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Model
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Driver Name
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Driver Code
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          Quantity
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          LOADINGORDER NO
                        </td>
                        <td className="py-2 px-4 text-left border border-gray-300">
                          JOURNEY NO
                        </td>
                      </tr>
                    </thead>
                    <tbody className="">
                      {filtTrucks?.map((value, index) => {
                        return (
                          <tr
                            className={
                              index < truckDetails.length - 1
                                ? "border-b cursor-pointer text-[12px]"
                                : "border-b cursor-pointer text-[12px] "
                            }
                            onClick={() => {
                              handleRowClick(value);
                              setShowVehicles(false);
                              handleCheckboxChange(value);
                            }} // Handle row click
                          >
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.VEHICLE ? value.VEHICLE : ""}
                            </td>

                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.TRAILER ? value.TRAILER : "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.MODEL ? value.MODEL : ""}
                            </td>

                            <td className="py-2 px-4 text-left border border-gray-300">
                              {value.DRIVDERNAME ? value.DRIVDERNAME : "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {" "}
                              {value.DRIVERCODE ? value.DRIVERCODE : "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {" "}
                              {value.QTY ? value.QTY : "0"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {" "}
                              {value.LOADINGORDERNO
                                ? value.LOADINGORDERNO
                                : "N/A"}
                            </td>
                            <td className="py-2 px-4 text-left border border-gray-300">
                              {" "}
                              {value.JOURNEYNO ? value.JOURNEYNO : "N/A"}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <>
                    <h1 className="text-lg text-red-500">
                      No Data Available for the provided List Of Trucks for the
                      Contract No Selected
                    </h1>
                  </>
                )}
              </div>
            </div>
          )}
        </div>

        {/* <div className="mt-4 p-4 bg-gray-100 rounded-lg shadow">
          <div className="lg:flex items-center gap-3">
            <span className="text-lg font-semibold">Select Vehicle :</span>
            <input
              className="w-[200px] h-7 lg:ml-2 pr-2"
              readOnly
              value={selectedRow ? selectedRow?.VEHICLE : ""}
            ></input>
            <button
              className="  border border-black bg-[#002d62] text-white rounded-md px-3  lg:ml-2 mr-1 h-7 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
              onClick={() => {
                if (!contractno) {
                  alert("please select a contract");
                } else {
                  setShowVehicles(true);
                }
              }}
            >
              ...
            </button>
          </div>
          {selectedRow && (
            <div className="lg:flex items-center gap-5 mt-5 uppercase">
              <div className="details-container">
                <div className="lg:flex mb-2">
                  <p className="font-bold w-36">Trailer:</p>
                  <p>{selectedRow?.TRAILER || "N/A"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-36">Model:</p>
                  <p>{selectedRow?.MODEL || "N/A"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-36">Driver Name:</p>
                  <p>{selectedRow?.DRIVDERNAME || "N/A"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-36">Driver Code:</p>
                  <p>{selectedRow?.DRIVERCODE || "N/A"}</p>
                </div>
              </div>
              <div className="details-container">
                <div className="lg:flex mb-2">
                  <p className="font-bold w-52">Quantity :</p>
                  <p>{selectedRow?.QTY || "0"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-52">LOADINGORDER NO :</p>
                  <p>{selectedRow?.LOADINGORDERNO || "0"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-52">JOURNEY NO :</p>
                  <p>{selectedRow?.JOURNEYNO || "0"}</p>
                </div>
                <div className="lg:flex mb-2">
                  <p className="font-bold w-52">&nbsp;</p>
                  <p>&nbsp;</p>
                </div>
              </div>
            </div>
          )}
        </div> */}

        {/* Main tab */}
        {/* <div className="mt-1">
          <Tabs selectedIndex={selectedTabIndex} onSelect={handleTabSelect}>
            <TabList className="grid grid-cols-3 gap-1 border-b-2 border-gray-300">
              {tabs.map((tab, index) => (
                <Tab
                  key={tab.id}
                  className={`px-4 py-1 cursor-pointer text-xs text-red-500 rounded-t-md hover:bg-gray-300 ${
                    index === selectedTabIndex
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200"
                  }`}
                >
                  {tab.title}
                </Tab>
              ))}
            </TabList>
            <div className="border border-gray-300 rounded-b-md">
              {tabs.map((tab, index) => (
                <div
                  key={tab.id}
                  style={{
                    display: index === selectedTabIndex ? "block" : "none",
                  }}
                >
                  {tab.content}
                </div>
              ))}
            </div>
          </Tabs>
        </div> */}
      </section>

      <section className="hidden print:block">
        <main className="relative my-2  mx-[50px] w-[705px] h-[942px] bg-slate-50 p-[10px] text-[10px]">
          <section className="border-[1.5px] border-blue-900 rounded-[10px] my-3 w-[100%] p-[10px]">
            <section>
              <h2 className="text-center font-bold text-[16px] underline">
                {menu}
              </h2>
            </section>
            <section className="feilds_top__goods">
              <h1>CONTRACT NO</h1>
              <p>{contractno ? contractno : ""}</p>
              <h1>JOB TYPE</h1>
              <p>{selJobType ? selJobType : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>CARGO CATEGORY</h1>
              <p> {cargoCategory ? cargoCategory : ""}</p>
              <h1>CARGO CLASSIFICATION</h1>
              <p> {cargoClassification ? cargoClassification : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>DATE</h1>
              <p>{date ? moment(date).format("DD/MM/YYYY") : ""}</p>
              <h1>FROM </h1>
              <p>{from ? from : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>TO</h1>
              <p>{to ? to : ""}</p>
              <h1>ROUTE ID </h1>
              <p>{routeId ? routeId : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>LOADING POINT</h1>
              <p>{loadingPoint ? loadingPoint : ""}</p>
              <h1>OFF LOADING POINT</h1>
              <p>{selOffLoadingPoint ? selOffLoadingPoint : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>LOCATION</h1>
              <p>{selLocation ? selLocation : ""}</p>
              <h1>CURRENCY</h1>
              <p>{currency ? currency : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>QUANTITY TO LOAD</h1>
              <p>{qty ? qty : ""}</p>
              <h1>FUEL RATE</h1>
              <p>{fuelRate ? fuelRate : ""}</p>
            </section>
            <section className="feilds_top__goods">
              <h1>EXCHANGE RATE</h1>
              <p>{exchangeRate ? exchangeRate : ""}</p>
              <h1>NARRATION</h1>
              <p>{narration ? narration : ""}</p>
            </section>
            <table class="table-print">
              <thead>
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                  <td className="py-2 px-4 text-left border border-gray-300">
                    Truck
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    Model
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    Trailer
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    Driver Name
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    Driver Code
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    LOADINGORDER NO
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    JOURNEY NO
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    FUELVOUCHER NO
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    MILEAGEVOUCHER NO
                  </td>
                </tr>
              </thead>
              <tbody>
                {filtTrucks?.map((value, index) => {
                  return (
                    <tr className="table-row">
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.VEHICLE ? value.VEHICLE : ""}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.MODEL ? value.MODEL : ""}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.TRAILERNAME ? value.TRAILERNAME : ""}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.DRIVERNAME ? value.DRIVERNAME : ""}
                      </td>
                      <td className="py-2 px-4 text-left border border-gray-300">
                        {value.DRIVERCODE ? value.DRIVERCODE : ""}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.LOADINGORDERNO ? value.LOADINGORDERNO : ""}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.JOURNEYNO ? value.JOURNEYNO : ""}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.FUELVOUCHERNO ? value.FUELVOUCHERNO : ""}
                      </td>
                      <td className="py-2 px-4 text-right border border-gray-300">
                        {value.MILEAGEVOUCHERNO ? value.MILEAGEVOUCHERNO : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </section>
          <div className="bottom__sign">
            <h3 className="">Recived BY :</h3>
            <p>________</p>
            <h3 className="">Sign :</h3>
            <p>________</p>
            <h3 className=""> Date :</h3>
            <p>________</p>
            <h3 className="">Time :</h3>
            <p>________</p>
          </div>
          <div className="bottom__sign">
            <h3 className="">Checked BY :</h3>
            <p>________</p>
            <h3 className="">Sign :</h3>
            <p>________</p>
            <h3 className=""> Date :</h3>
            <p>________</p>
            <h3 className="">Time :</h3>
            <p>________</p>
          </div>
          <section className="text-center my-[100px]">
            <h1>Powered by Genius Business System</h1>
            <h1>Marstrack ERP</h1>
            <h1>www.gbsafrica.net</h1>
          </section>
        </main>
      </section>
    </div>
  );
};

export default FuelAndMileageVouchers;
